import { sizeTypeDisplay } from "pages/deal/constants/deal_enums";

export const LOT_SIZE_TYPE_OPTIONS: any = [
  { key: "square_feet", label: sizeTypeDisplay.square_feet },
  { key: "acres", label: sizeTypeDisplay.acres },
];
